import React, { useEffect } from "react";
import { Clock } from "lucide-react";
import { useQzTrayConnection } from "../../../hooks/qztray/useQzTrayConnection";

/**
 * 🕒 ConnectionLastCheckedBox
 * Muestra la fecha y hora de la última verificación del cliente QZ Tray.
 */
const ConnectionLastCheckedBox: React.FC = () => {
  const { status, fetchStatus } = useQzTrayConnection();

  useEffect(() => {
    fetchStatus();
  }, []);

  const lastChecked = status?.checkedAt
    ? new Date(status.checkedAt).toLocaleString("es-SV", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })
    : "Sin verificación aún";

  return (
    <div className="rounded-lg border border-stroke bg-white dark:border-strokedark dark:bg-boxdark shadow-md p-6 flex flex-col justify-between transition-colors">
      {/* 🔹 Encabezado */}
      <div className="flex items-center justify-start gap-3 mb-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 dark:bg-primary/15">
          <Clock className="h-5 w-5 text-primary" />
        </div>
        <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">
          Última Verificación
        </h4>
      </div>

      {/* 🔸 Valor principal */}
      <div className="text-center mt-1">
        <span className="block text-[15px] font-bold text-gray-900 dark:text-white leading-tight">
          {lastChecked}
        </span>
        <p className="text-[13px] text-gray-500 dark:text-gray-400 mt-1">
          Fecha y hora del último ping
        </p>
      </div>
    </div>
  );
};

export default ConnectionLastCheckedBox;
